import React from "react";
import logo from "../../../assets/images/inc-logo.png";
import "../../../assets/css/style.css";
import LicesneOrga from "../../../assets/images/licenseOrganization.png";
import LicenseUser from "../../../assets/images/licesnseUser.png";
import LicenseSucess from "../../../assets/images/licenseSucess.png";
import LicenseLogin from "../../../assets/images/licenseLogin.png";
import SubUser from "../../../assets/images/subUser.png";
import SubUser2 from "../../../assets/images/subUser2.png";
import SubUser3 from "../../../assets/images/subUser3.png";
import SubUser4 from "../../../assets/images/subUser4.png";
import SubUser5 from "../../../assets/images/subUser5.png";
import SubUser6 from "../../../assets/images/subUser6.png";
import SubUser7 from "../../../assets/images/subUser7.png";

const UserDetails = () => {
  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <div className="inc-card-title">
            <h3>Device Simulator</h3>
          </div>
          <br />
          <p style={{ paddingLeft: "2em" }}>
            Device Simulator Description The Device Simulator allows you to
            onboard and test network devices using predefined configurations.
            This is especially useful for validating system behavior, simulating
            real-world scenarios, and ensuring end-to-end platform readiness
            before deploying actual hardware. Below are the sample
            configurations you can use to simulate Access Points (APs) and
            Switches (SWs):
          </p>
          <div className="device-table-section" style={{ padding: "0 2em" }}>
            <hr />
            <h5>Access Point (AP) Simulation</h5>
            <table
              className="table table-bordered"
              style={{ width: "100%", marginBottom: "2em" }}
            >
              <thead>
                <tr>
                  <th>Serial Number</th>
                  <th>MAC Address</th>
                  <th>Model</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>6LK1002G58725</td>
                  <td>9C-C9-EB-A1-2D-5A</td>
                  <td>WAX620</td>
                </tr>
                <tr>
                  <td>7LK2003H68838</td>
                  <td>8D-D0-FC-B2-3E-6E</td>
                  <td>WAX620</td>
                </tr>
              </tbody>
            </table>

            <h5>Switch (SW) Simulation</h5>
            <table className="table table-bordered" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Serial Number</th>
                  <th>MAC Address</th>
                  <th>Model</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>4S92056TG0008</td>
                  <td>18:46:D0:3B:58:21</td>
                  <td>GS110TPP</td>
                </tr>
                <tr>
                  <td>3R819455F0001</td>
                  <td>08:36:C9:2A:47:17</td>
                  <td>GS110TPP</td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>
          <p style={{ paddingLeft: "2em" }}>
            💡 Use these simulated device profiles only to validate onboarding
            flows, configuration sync, and role-based access behaviors within
            the platform.
          </p>
        </div>

        <footer>
          <div className="container">
            Powered by{" "}
            <a
              href="https://www.vvdntech.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              VVDN Technologies
            </a>
          </div>
        </footer>
      </div>
    </>
  );
};

export default UserDetails;
